import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";
import { Message } from 'element-ui'
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        sideMenuCollapse: false,
        menus: [],
        role: 0,
        userInfo: {
            bindStatus: 0
        },
        token: "",
        ssoURL: "",
        exclude: ["Authorise"],
        editFlag: false,
        editForm: {},
        province:[],
    },
    mutations: {
        updateState(state, data) {
            Object.assign(state, data);
        },
        SET_EDITFLAG: (state, editFlag) => {
            state.editFlag = editFlag
        },
        SET_EDITFORM: (state, editForm) => {
            state.editForm = editForm
        }
    },
    actions: {
        saveFormEdit({ commit }, params) {
            //添加token
            axios.defaults.headers["Authorization"] = this.state.token;
            return new Promise((resolve, reject) => {
                axios
                    .post("/srMenu/submit", {
                        ...params,
                    })
                    .then((res) => {
                        if (res.data?.code === 200) {
                            Message.success("Save successfully")
                            commit('SET_EDITFLAG', false)
                            commit('SET_EDITFORM', {})
                        } else {
                            Message.error(res.data?.msg)
                        }
                        resolve()
                    })
                    .catch((error) => {
                        Message.error("Save failed")
                        reject(error)
                    })
            })
        },
    },
    plugins: [
        createPersistedState({
            key: process.env.VUE_APP_COOKIE_KEY,
            storage: {
                getItem: key => Cookies.get(key),
                setItem: (key, value) => {
                    // expire in 2 hours
                    let expires = new Date(new Date().getTime() + 2 * 60 * 60 * 1000);
                    Cookies.set(key, value, {expires: expires, secure: true, httpOnly: true})
                },
                removeItem: key => Cookies.remove(key)
            }
        })
    ]
});
